var map = {
  "./pl-PL/grafana.json": [
    "19388",
    [
      74573
    ]
  ],
  "./de-DE/grafana.json": [
    "23082",
    [
      71479
    ]
  ],
  "./id-ID/grafana.json": [
    "10130",
    [
      4495
    ]
  ],
  "./fr-FR/grafana.json": [
    "35648",
    [
      75545
    ]
  ],
  "./en-US/grafana.json": [
    "19521",
    [
      47738
    ]
  ],
  "./it-IT/grafana.json": [
    "46834",
    [
      80783
    ]
  ],
  "./nl-NL/grafana.json": [
    "91716",
    [
      21445
    ]
  ],
  "./cs-CZ/grafana.json": [
    "7299",
    [
      28640
    ]
  ],
  "./ja-JP/grafana.json": [
    "37681",
    [
      11114
    ]
  ],
  "./pt-BR/grafana.json": [
    "12288",
    [
      92441
    ]
  ],
  "./pt-PT/grafana.json": [
    "37996",
    [
      91645
    ]
  ],
  "./zh-Hans/grafana.json": [
    "29538",
    [
      86015
    ]
  ],
  "./hu-HU/grafana.json": [
    "23466",
    [
      66167
    ]
  ],
  "./ru-RU/grafana.json": [
    "88018",
    [
      28239
    ]
  ],
  "./es-ES/grafana.json": [
    "70680",
    [
      95553
    ]
  ],
  "./sv-SE/grafana.json": [
    "51579",
    [
      71912
    ]
  ],
  "./ko-KR/grafana.json": [
    "43303",
    [
      89068
    ]
  ],
  "./tr-TR/grafana.json": [
    "46208",
    [
      76025
    ]
  ],
  "./zh-Hant/grafana.json": [
    "14791",
    [
      96204
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 93690;
module.exports = __rspack_async_context;
